import React, { useEffect, useRef, useState } from "react";
import status from "../../../../asset/images/Statustick.svg";
import uploadIcon from "../../../../asset/images/upload-file.svg";
import attachIcon from "../../../../asset/images/attachment-offmarket.svg";
import { Dealer_Mapping } from "../../../../Configuration/API_URL";
import {
  decryptData,
  formatDate,
  noDataFound,
  validateFile
} from "../../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance from "../../../../CommonMethhods/axiosInstance";
import Loader from "../../../../Components/Common/Loader";
import closeIcon from "../../../../asset/images/close-gray.svg";
import SmallLoader from "../../../../Components/Common/smallLoader";


function ValidationResults({ validationData, setConfirmationData, onNext, isReadOnly,
  selectedRequest, refreshHistory, isFromMyRequest, setSelectedSR }) {
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [removedDoc, setRemovedDoc] = useState(false);
  const fileInputRef = useRef(null);
  const [submitLoader, setSubmitLoader] = useState(false);

  const batchId = validationData?.batchId || selectedRequest?.batchId;


  const rowPreviewDetails = async () => {
    setLoader(true);

    try {
      const getDetails = await axiosInstance.get(
        `${Dealer_Mapping.validationRowPreview}/${batchId}`,
      );
      const decrypted = JSON.parse(
        decryptData(getDetails?.data)
      );

      if (decrypted?.status === 0) {
        console.log(decrypted, "rowTables");
        setRowData(decrypted?.data)

      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if(batchId){
    rowPreviewDetails();
    }
  }, [batchId]);

  const hasSupportingDoc =
    (!!uploadedFile || !!rowData?.approvalDocLink) && !removedDoc;

  // const supportingDocName = uploadedFile?.name
  //   ? uploadedFile.name
  //   : rowData?.approvalDocLink
  //     ? decodeURIComponent(
  //       rowData.approvalDocLink
  //         .split("/")
  //         .pop()
  //         .split("?")[0]
  //     )
  //     : "";

  const handleSubmit = async () => {
    if (!validationData?.validRows || validationData.validRows === 0) {
      toast.error("No valid rows available to submit.");
      return;
    }
    setSubmitLoader(true);

    try {
      let url = "";
      let response;

      if (isFromMyRequest) {
        url = `${Dealer_Mapping.singleMappingSubmit}/${validationData?.batchId}/submit`;

        response = await axiosInstance.put(url);
      } else {
        url = `${Dealer_Mapping.singleMappingSubmit}/${validationData?.batchId}/submit`;

        response = await axiosInstance.put(url);
      }


      const decryptedresp = decryptData(response.data);
      const decrypted = JSON.parse(decryptedresp)

      console.log(decrypted, "decrypted");

      if (decrypted?.status === 0) {
        toast.success(decrypted.message);
        if (isFromMyRequest) {
          setSelectedSR(null);
          refreshHistory?.();
        } else {
          setConfirmationData({
            batchId: validationData?.batchId,
            type: "submit",
          });
          onNext();
        }
      } else {
        toast.error(decrypted.message);
      }
    } catch (error) {
      const decryptedResp = decryptData(error?.response?.data);
      const decryptedError = JSON.parse(decryptedResp);
      toast.error(decryptedError?.message)
      console.log(decryptedError);
    } finally {
      setSubmitLoader(false);
    }

  };


  return (
    <div className="wrap-preview-section">
      <div className="dl-map-table">
        <div className="dl-map-headers wrap-header-valid">
          {selectedRequest?.batchId ? 

              <div className="wrap-title-batch wrap-valid">
                <div className="status-content">
                  <span className="ckr-section-title">{selectedRequest?.batchId}</span>
                  {selectedRequest?.status !== "" ?
                    <span
                      className={`${selectedRequest.status.toLowerCase() === "pending" ? "status-pending" :
                        selectedRequest.status.toLowerCase() === "approved" ? "status-approved" :
                          selectedRequest.status.toLowerCase() === "rejected" ? "status-rejected" :
                            selectedRequest.status.toLowerCase() === "draft" ? "status-draft" : ""
                        }`}>
                      {selectedRequest?.status}
                    </span>
                    : "-"}
                </div>

              {!isReadOnly &&
                <div className="wrap-title">  
                  <p className="table-title valid-title">Validation Summary</p>
                  <p className="row-count">mapping_batch_mar20.xlsx · {validationData?.totalRows} rows</p>
                </div>
              }
                </div>
                
                
                :
                !isReadOnly &&
                <>
                 <p className="table-title">Validation Summary</p>
                 <p className="row-count">mapping_batch_mar20.xlsx · {validationData?.totalRows} rows</p>
                </>
                
              } 

        </div>
        {!isReadOnly &&
        <div className="valid-section">
          <div className="wrap-val">
            <label className="text-val">Total</label>
            <span>{validationData?.totalRows}</span>
          </div>

          <div className="wrap-val">
            <label className="text-val">Valid</label>
            <span>{validationData?.validRows}</span>
          </div>

          <div className="wrap-val">
            <label className="text-val">Invalid</label>
            <span>{validationData?.failedRows}</span>
          </div>

        </div>
        }

        {validationData?.failedRows > 0 &&
          <>
            <div className="dl-map-headers">
              <p className="table-title">Row Errors</p>
            </div>


            <div className="err-wrapper">

              {validationData?.failedDetails?.map((item, index) => (
                <div className="err-card" key={index}>
                  <label className="err-title">{item.clientCode}</label>

                  {item.failures.map((failure, i) => (
                    <span key={i} className="missing-cont">
                      {failure}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </>
        }

      </div>

      <div className="dl-map-table">
        <div className="dl-map-headers">
          <p className="table-title">Row Preview</p>

          {rowData?.requests?.length > 0 &&
            <div className={`${hasSupportingDoc ?
              "wrap-upload-section doc-name disable-field" :
              "wrap-upload-section wrap-upload-red"}`}
              onClick={(e) => {
                e.stopPropagation();
                if (hasSupportingDoc) return;
                // handleUploadClick(index);
              }}
            >
              {hasSupportingDoc ?
                <img src={uploadIcon} alt="upload icon" /> :
                <img src={attachIcon} alt="attachment" />}

              <button
                className={`${hasSupportingDoc
                  ? "upload-doc-btn"
                  : "upload-doc-btn upload-doc-btn-red"
                  }`}
                   title={rowData?.approvalDocFilename}
                disabled={!hasSupportingDoc}
                onClick={(e) => {
                  if (hasSupportingDoc) {
                    e.preventDefault();
                    window.open(rowData.approvalDocLink, "_blank");
                  }
                }}
              >
                {rowData?.approvalDocFilename || "Upload supporting document"}
              </button>

              {/* {hasSupportingDoc && (
                <img
                  className="close"
                  src={closeIcon}
                  alt="close"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();

                    setUploadedFile(null);
                    setRemovedDoc(true);

                    if (fileInputRef.current) {
                      fileInputRef.current.value = "";
                    }
                  }}
                />
              )} */}
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                style={{ display: "none" }}
                onChange={validateFile}
              />
            </div>
          }
        </div>
        <div className="dlmap-table-wrapper">
          {loader ?
            <div className="loader-alignment">
              <Loader />
            </div>
            :
            <>
              {rowData?.requests && rowData?.requests?.length > 0 ?

                <table className="map-table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Request Date</th>
                      <th>Client Code</th>
                      {/* <th>Client Name</th> */}
                      <th>Old Dealer Code</th>
                      <th>New Dealer Code</th>
                      <th>Effective Date</th>
                      <th>Reason for Change</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rowData?.requests.map((data, index) => (
                      <tr
                        key={data.id}
                        className={data?.id === data.id ? "ckr-active-row" : ""}
                      >
                        <td>{index + 1}</td>
                        <td>{formatDate(data?.reqDate) || "-"}</td>
                        <td>{data?.ucc || "-"}</td>
                        <td>{data.oldDealerCode || "-"}</td>
                        <td>{data.newDealerCode || '-'}</td>
                        <td>{formatDate(data.startDate) || "-"}</td>
                        <td>{data?.reason}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                :
                <div className="step-content report-error-message">
                  {noDataFound()}
                </div>}
            </>
          }
        </div>
      </div>

      {validationData?.validRows > 0 &&
        <div className="success-banner">
          <img src={status} alt="status icon" />
          <span className="bold-text">{validationData?.validRows} valid rows ready.</span>
          {" "} Checker will receive email notification on submit. Since the supporting document is missing, 
          upon submission this service request will be automatically saved as draft.
        </div>
      }

      <div className="mapping-footer-actions">
        {!isReadOnly ?
        <>
        <button className="back-btn" onClick={() =>{
          if (isFromMyRequest) {
          setSelectedSR(null);
          refreshHistory?.();
        } else {
          setConfirmationData({
            batchId: validationData?.batchId,
            type: "submit",
          });
          onNext();
        }}}
        
        >SAVE AS DRAFT</button>
        <button className="submit-btns"
          onClick={handleSubmit}>
          {submitLoader ?
            <SmallLoader />
            :
            validationData?.validRows > 0
              ? `SUBMIT ${validationData.validRows} VALID ROW${validationData.validRows > 1 ? "S" : ""}`
              : "SUBMIT"
          }
        </button>
        </>
        :
        <button className="back-btn" 
          onClick={() => setSelectedSR(null)}
        >
          CANCEL
        </button>
        }
        
      </div>

    </div>
  );
}

export default ValidationResults;